import DashboardWalletSociety from './DashboardWalletSociety';
export default DashboardWalletSociety;
